import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  //inject services
  constructor(private mds: MetaService) { }

  //initialize the component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Home';
    var description = 'RegScale home page describing the primary benefits and value proposition for the use of our Compliance Management Platform';
    var keywords = 'RegScale, home page, about, value proposition, market research, explainer video, compliance, audits';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
